<template>
  <video
    ref="videoPlayer"
    :data-setup="JSON.stringify({
      fluid: true,
    })"
    class="video-js vjs-big-play-centered">
  </video>
</template>

<script>
import videojs from 'video.js';
import './dash.min.js';
import './video-js-dash.min.js';
import 'video.js/dist/video-js.css';

export default {
  name: 'video-player',
  props: {
    options: {
      type: Object,
      default() {
        return {};
      },
    },
    disableScrub: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      player: null,
      highestTime: 0,
    };
  },
  mounted() {
    // const overrideNative = false;
    this.player = videojs(this.$refs.videoPlayer, {
      ...this.options,
      html5: {
        dash: {
          setLimitBitrateByPortal: true,
          setMaxAllowedBitrateFor: ['video', 2000],
        },
        // vhs: {
        //   withCredentials: true,
        //   debug: true,
        //   enableWorker: true,
        //   overrideNative: true,
        // },
        // nativeVideoTracks: !overrideNative,
        // nativeAudioTracks: !overrideNative,
        // nativeTextTracks: !overrideNative,
      },
    }, () => {
      this.player.on('ended', this.onEnded);
      this.player.on('ready', this.onReady);
    });
    videojs.use('*', this.disableForwardScrubbing);
  },
  beforeUnmount() {
    if (this.player) {
      this.player.dispose();
    }
  },
  methods: {
    onEnded() {
      this.$emit('on-ended');
    },
    onReady() {
      this.$emit('on-ready');
    },
    disableForwardScrubbing(player) {
      const $vm = this;
      return {
        setSource(srcObj, next) {
          next(null, srcObj);
        },
        currentTime(time) {
          if (time > $vm.highestTime) {
            $vm.highestTime = time;
          }
          return time;
        },
        setCurrentTime(desiredTime) {
          const currentTime = player.currentTime();
          if (!$vm.disableScrub || desiredTime < $vm.highestTime) {
            return desiredTime;
          }
          return currentTime;
        },
      };
    },
  },
};
</script>

<style scoped lang="scss">
.video-js {
  height: 450px;
  width: 100%;

  @media only screen and (max-width: $mobile-max) {
    height: 335px;
    width: 100%;
  }
}
</style>
